import {SFC, SVGProps} from 'react';
import styled from 'styled-components';
import AllInclusiveSvg from './allInclusive.svg';

const AllInclusiveIcon = styled(AllInclusiveSvg as JSX.Element)(
  props => `
  width: ${props => props.width};
  height: ${props => props.height};
  fill: ${props => props.color};
  margin: ${props => props.margin};
  cursor: pointer;
`,
);

export default AllInclusiveIcon;
